"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ScreenSize_1 = __importDefault(require("@web/common/ScreenSize"));
class ScrollingState {
    static getScrollbarWidth() {
        return window.innerWidth - document.documentElement.clientWidth;
    }
    static disableScrolling() {
        if (ScreenSize_1.default.isSmallScreen()) {
            this.html.classList.remove('no-scroll');
            this.body.classList.remove('no-scroll');
            this.html.classList.add('mobile-no-scroll');
            this.body.classList.add('mobile-no-scroll');
            this.html.style.marginRight = '';
        }
        else {
            const scrollbarWidth = this.getScrollbarWidth();
            this.html.classList.remove('mobile-no-scroll');
            this.body.classList.remove('mobile-no-scroll');
            this.html.classList.add('no-scroll');
            this.body.classList.add('no-scroll');
            this.html.style.marginRight = `${scrollbarWidth}px`;
        }
    }
    static enableScrolling() {
        this.html.classList.remove('no-scroll', 'mobile-no-scroll');
        this.body.classList.remove('no-scroll', 'mobile-no-scroll');
        this.html.style.marginRight = '';
    }
}
ScrollingState.html = document.documentElement;
ScrollingState.body = document.body;
exports.default = ScrollingState;
